import { isSSR } from '@helpers/ssr';
import { ReactComponent as SvgEmail } from '@img/icons/share/email.svg';
import { ReactComponent as SvgFacebook } from '@img/icons/share/facebook.svg';
import { ReactComponent as SvgInstagram } from '@img/icons/share/instagram.svg';
import { ReactComponent as SvgLinkedIn } from '@img/icons/share/linkedin.svg';
import { ReactComponent as SvgPinterest } from '@img/icons/share/pinterest.svg';
import { ReactComponent as SvgTikTok } from '@img/icons/share/tiktok.svg';
import { ReactComponent as SvgTwitter } from '@img/icons/share/twitter.svg';
import { ReactComponent as SvgVimeo } from '@img/icons/share/vimeo.svg';
import { ReactComponent as SvgWhatsApp } from '@img/icons/share/whatsapp.svg';
import { ReactComponent as SvgYouTube } from '@img/icons/share/youtube.svg';
import * as React from 'react';
import S from './SocialLinks.styles';
const SocialIconMap = {
    email: SvgEmail,
    facebook: SvgFacebook,
    instagram: SvgInstagram,
    linkedin: SvgLinkedIn,
    pinterest: SvgPinterest,
    tiktok: SvgTikTok,
    twitter: SvgTwitter,
    vimeo: SvgVimeo,
    whatsapp: SvgWhatsApp,
    youtube: SvgYouTube,
};
const SocialLinks = (props) => {
    if (isSSR()) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, rel: "noreferrer noopener", target: item.target, title: item.title }, renderIcon(item.type))))))));
    function renderIcon(type) {
        if (!Object.keys(SocialIconMap).includes(type)) {
            console.error(`Unsupported icon type`, type);
            return React.createElement(S.Icon, { "aria-hidden": "true" });
        }
        return React.createElement(S.Icon, { as: SocialIconMap[type], "aria-hidden": "true" });
    }
};
export default SocialLinks;
